export default "__VITE_ASSET__BC$ea8d$__"